import React from 'react';
import ChartComponent, { Chart } from 'react-chartjs-2';
import { AutoSizer } from 'react-virtualized';
import {ButtonComponent, Route} from 'oca-lib-web'
import BarChartIcon from '@mui/icons-material/BarChart'
import IconButton from "@mui/material/IconButton";

function hslToRgb(h, s, l) {
    var r;
    var g;
    var b;

    if (s === 0) {
        r = g = b = l; // achromatic
    } else {
        // noinspection JSAnnotator
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1/6) return p + (q - p) * 6 * t;
            if (t < 1/2) return q;
            if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
            return p;
        }

        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;

        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return [ Math.round(r * 255), Math.round(g * 255), Math.round(b * 255) ];
}

export function getColorStart(index, length) {
    return hslToRgb(index / length, 1, 0.7);
}
export function getColorEnd(index, length) {
    return hslToRgb(index / length, 1, 0.4);
}
export function getColorAverage(index, length) {
    return hslToRgb(index / length, 1, 0.55);
}

// convert our data to chart.js format
export function customToNormalData(origData) {
    const data = {
        labels: [],
        datasets: [{ data: [] }]
    }
    for (let item of origData) {
        data.labels.push(item.label);
        data.datasets[0].data.push(item.value);
    }
    return data;
}

/*export function formatTime(seconds) {
    let hours = 0, minutes = 0;
    if (seconds >= 60 * 60) {
        hours = Math.floor(seconds / 60 / 60);
        seconds -= hours * 60 * 60;
    }
    if (seconds >= 60) {
        minutes = Math.floor(seconds / 60);
        seconds -= minutes * 60;
    }

    let result = [];
    let units = '';
    if (hours) {
        result.push(hours);
        units = 'h';
    }
    if (hours || minutes) {
        result.push(((result.length && minutes < 10) ? '0' : '') + minutes);
        if (!units)
            units = 'm';
    }
    if (seconds)
        result.push(((result.length && seconds < 10) ? '0' : '') + seconds);

    return result.join(':') + (result.length === 3 ? '' : (units || 's'));
}*/

Chart.defaults.StyledDoughnut = Chart.defaults.doughnut;
Chart.controllers.StyledDoughnut = class StyledDoughnut extends Chart.controllers.doughnut {
    constructor(chart, datasetIndex) {
        if (chart.options.print) {
            chart.options.animation = false;
        }

        if (!chart.options.decorFill) {
            chart.options.decorFill = '#f6f7fb';
        }

        if (!chart.options.decorGradient) {
            chart.options.decorGradient = [[0, 'rgba(72,134,255,0.07)'], [1, 'rgba(72,134,255,0)']];
        }

        // Automatic colors
        chart.data.datasets[datasetIndex].backgroundColor = [];
        for (let max = chart.data.datasets[datasetIndex].data.length, i = 0; i < max; i++) {
            if (chart.options.print) {
                let [r, g, b] = getColorAverage(i, max);
                chart.data.datasets[datasetIndex].backgroundColor.push(`rgb(${r},${g},${b})`);
            } else {
                let [r1, g1, b1] = getColorStart(i, max);
                let [r2, g2, b2] = getColorEnd(i, max);

                let gradient = chart.ctx.createLinearGradient(0, 0, 0, chart.canvas.height);
                gradient.addColorStop(0, `rgb(${r1},${g1},${b1})`);
                gradient.addColorStop(1, `rgb(${r2},${g2},${b2})`);
                
                chart.data.datasets[datasetIndex].backgroundColor.push(gradient);
            }
        }

        super(chart, datasetIndex);
    }
    
    draw(...args) {
        let center = this.chart.canvas.width / 2;
        let radius = (this.chart.options.cutoutPercentage - 10) * this.chart.canvas.width / 200;

        this.chart.ctx.save();
        if (this.chart.options.print) {
            this.chart.ctx.fillStyle = this.chart.options.decorFill;
        } else {
            this.chart.ctx.fillStyle = this.chart.ctx.createLinearGradient(0, 0, 0, 2 * radius);
            for (let stop of this.chart.options.decorGradient)
            this.chart.ctx.fillStyle.addColorStop(stop[0], stop[1]);
        }
        this.chart.ctx.beginPath();
        this.chart.ctx.lineWidth = 0;
        this.chart.ctx.arc(center, center, radius, 0, 2 * Math.PI, true);
        this.chart.ctx.closePath();
        this.chart.ctx.fill();
        this.chart.ctx.restore();

        super.draw(...args)
    }
}

class StyledDoughnutChart extends React.Component {

    getChart({ width }) {
        if (!width)
            return null;

        const margin = width / 5;
        //let margin = 100;
        const height = width - 1.25 * margin;
        const innerWidth = width - 2 * margin;
        const innerHeight = innerWidth;

        return (
            <div className="styledWrapper__decorated" style={{ width, height, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ width: innerWidth, height: innerHeight }}>
                    <ChartComponent type="StyledDoughnut"
                                    options={this.props.options}
                                    data={customToNormalData(this.props.data)}
                                    width={innerWidth}
                                    height={innerHeight}
                                    redraw />
                </div>
            </div>
        );
    }

    render() {
        if (!this.props.data)
            return null;

        if (this.props.width)
            return this.getChart({ width: this.props.width });

        return (
            <AutoSizer disableHeight>
                {({ width }) => this.getChart({ width })}
            </AutoSizer>
        );
    }
}

export const _Chart = Chart;
export default StyledDoughnutChart;
